import React from 'react';

import styles from './ProgressBar.module.scss';

type TypePercentInfo = {
  value: number;
  color: 'primary' | 'secondary' | 'tertiary' | 'info' | 'success' | 'warning' | 'error' | 'point';
};
type TypeProgressBarProps = {
  percent: TypePercentInfo | TypePercentInfo[];
};
const ProgressBar = ({ percent }: TypeProgressBarProps) => {
  const percentArray = Array.isArray(percent) ? percent : [percent];

  const positionInfo = percentArray
    .reduce(
      (acc, cur, index) => {
        const currentInfo = {
          left: acc[index].left + acc[index].width,
          width: cur.value,
        };

        return [...acc, currentInfo];
      },
      [{ left: 0, width: 0 }]
    )
    .slice(1);

  return (
    <div className={styles['progress-bar']}>
      {percentArray.map((item, index) => (
        <div
          key={`progress-${index}`}
          className={`
            ${styles['progress']}
            ${styles[`color-${item.color}`]}
        `}
          style={{
            width: `${positionInfo[index].width}%`,
            left: `${positionInfo[index].left}%`,
          }}
        />
      ))}
    </div>
  );
};

export default ProgressBar;
